module.exports = __webpack_public_path__ + "img/J11139.3913bccc.png";